import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateLoader } from '@ngx-translate/core';
import { Injector } from '@angular/core';
import { TranslationService } from '../services/api-services';
import { environment } from 'src/environments/environment';
import { makeStateKey, StateKey, TransferState } from '@angular/platform-browser';

export class CustomTranslateHttpLoader extends TranslateLoader {
  constructor(private readonly injector: Injector) {
    super();
  }

  override getTranslation(lang: string): Observable<Object> {
    const translationService = this.injector.get(TranslationService);
    const transferState = this.injector.get(TransferState);
    const key: StateKey<number> = makeStateKey<number>(lang);

    if (transferState.hasKey(key)) {
      return of(transferState.get<Object>(key, {}) as Object);
    }

    return translationService.getAllTranslations(lang, environment.version)
      .pipe(map(response => {
        transferState.set(key, response as Object);
        return response as Object;
      }));
  }
}
